
import { useGLTF } from "@react-three/drei";
import { useMemo } from "react";

useGLTF.preload("/turtle-v1.glb");

export default function Turtle() {
    const { scene } = useGLTF("/turtle-v1.glb");
    
    // Create meshes array only once
    const meshes = useMemo(() => {
        const meshArray = [];
        scene.traverse((child) => {
            if(child.isMesh){
                meshArray.push(child.clone()); 
            }
        });
        return meshArray;
    }, [scene]);

    return (
        <group scale={[0.5, 0.5, 0.5]} position-y={-0.25}>
            {meshes.map((mesh, index) => (
                <mesh
                    castShadow
                    key={index}
                    geometry={mesh.geometry}
                    material={mesh.material}
                />
            ))}
        </group>
    );
}